var React = require('react');

function OtherLists (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/Other-Lists","stroke":"none","strokeWidth":"1","fill":"currentColor","fillRule":"evenodd"},React.createElement("path",{"d":"M3,4 L17,4 C17.5522847,4 18,4.44771525 18,5 L18,5.5 C18,6.05228475 17.5522847,6.5 17,6.5 L3,6.5 C2.44771525,6.5 2,6.05228475 2,5.5 L2,5 C2,4.44771525 2.44771525,4 3,4 Z M3,9 L14,9 C14.5522847,9 15,9.44771525 15,10 L15,10.5 C15,11.0522847 14.5522847,11.5 14,11.5 L3,11.5 C2.44771525,11.5 2,11.0522847 2,10.5 L2,10 C2,9.44771525 2.44771525,9 3,9 Z M3,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,15.5 C12,16.0522847 11.5522847,16.5 11,16.5 L3,16.5 C2.44771525,16.5 2,16.0522847 2,15.5 L2,15 C2,14.4477153 2.44771525,14 3,14 Z","id":"path-1"})));
}

OtherLists.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 20 20","version":"1.1"};

module.exports = OtherLists;

OtherLists.default = OtherLists;
